import React from 'react';

const About = () => (
    <>
          <h2> This is About Page</h2> 
    </>
);
export default About